import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import "styles/global.css"
import { json } from 'stream/consumers';
import AuthService from 'service/AuthService';

const Verification: React.FC = () => {
  const [otpCode, setOtpCode] = useState<string>('');
  const [error, setError] = useState<string>('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { forgotPassword } = useSelector((state: any) => state.auth);

  const handleVerification = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    var email = forgotPassword?.email;
    var sessionId = forgotPassword?.sessionId;
    
    const authService = AuthService();
    try {
      const response = await authService.verifyForgotPassword(email, sessionId, otpCode);
      console.log('Verification Response:', response.data?.data);
      if (response.status === 200) {   
        if (response.data?.status == 'T') {
          navigate('/change-password');
        } else {
          setError('Invalid verification code');
          console.log('Invalid verification code');
        }
        // dispatch({ type: 'VERIFY_FORGOT_PASSWORD', payload: response.data?.data });
        // navigate('/reset-password');
      } else {
        setError('Failed to verify code');
      }
    } catch (error: any) {
      console.error('Error:', error);
      setError(error);
    }
  };

  return (
    <div className='container-fluid' style={{ padding: 0, height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className='row h-100'>
        <div className='col-md-12'>
          <form onSubmit={handleVerification} style={{ padding: 128 }}>
            <img src="/assets/logo/logo-transmore-hd.png" className='img-fluid rounded mx-auto d-block' alt="" srcSet="" style={{height:'20vh'}}/>
            <h1 className='tm-text-primary'>Sign in to your account</h1>
            <label htmlFor="">Please check your email to receice verification code</label>
            <br />
            <div className='row mt-2'>
              <div className='col-sm-12 pb-3'>
                <input id='otpCode' name='otpCode' type='otpCode' className='form-control' placeholder='Verification Code' onChange={(e) => setOtpCode(e.target.value)} required />
              </div>
              <div className='col-sm-12 pb-3'>
                <hr />
              </div>
              <div className='col-sm-12 pb-3 text-center'>
                <button type='submit' id='' name='createAccountButton' className='btn btn-primary w-100'>Verify</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Verification;